// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shipment-box';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 .563.562 3.938 9 7.312l8.438-3.375z' />
    <path d='M.563 3.938v10.124L9 17.439V7.313zm16.875 0v10.124L9 17.439V7.313zM13.64 5.456 5.203 2.081m10.266 10.294-1.406.563' />
  </g>
);

export const viewBox = '0 0 18 18';
